import { useState } from 'react'
import { useAddComment, useTaskComments } from '../hooks'
import { CommentItem } from './CommentItem'

interface CommentThreadProps {
  taskId: number
}

/**
 * Wątek komentarzy pod konkretnym taskiem - lista (chronologicznie asc) + textarea
 * "Dodaj komentarz". YAGNI v1: brak edycji/usuwania, plain text + whitespace-pre-wrap.
 */
export function CommentThread({ taskId }: CommentThreadProps) {
  const list = useTaskComments(taskId)
  const add = useAddComment(taskId)
  const [text, setText] = useState('')

  const submit = () => {
    if (!text.trim()) return
    add.mutate({ text: text.trim() }, { onSuccess: () => setText('') })
  }

  return (
    <div className="flex flex-col gap-2">
      <h4 className="text-xs uppercase text-slate-500">Komentarze</h4>
      <div className="flex-1 min-h-0">
        {list.isLoading && <p className="text-xs text-slate-400">Ładowanie…</p>}
        {list.data?.length === 0 && (
          <p className="text-xs text-slate-400 italic">Brak komentarzy.</p>
        )}
        {list.data?.map((c) => <CommentItem key={c.id} comment={c} />)}
      </div>
      <div className="mt-2">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Dodaj komentarz…"
          rows={3}
          className="w-full border rounded px-2 py-1 text-sm resize-y"
        />
        <div className="flex justify-end mt-1">
          <button
            type="button"
            disabled={!text.trim() || add.isPending}
            onClick={submit}
            className="px-3 py-1 text-xs bg-sky-600 text-white rounded disabled:opacity-50"
          >
            Wyślij
          </button>
        </div>
      </div>
    </div>
  )
}
